<template>
  <v-card flat  class="setup-subtab-content">

    <div class="">

      <div class="font-weight-bold">
        {{ $t('setup.filterFile') }}
      </div>
      <div>
        {{ $t('setup.filterInstructions') }}

        <ol>
          <li v-html="$t('setup.filterOption1')"></li>
          <li><a target="_blank" href="https://www.niso.org/standards-committees/kbart">KBART file</a></li>
        </ol>
        <div class="mt-2 mb-2">
          <img
            src="https://docs.unsub.org/~gitbook/image?url=https%3A%2F%2F2329511114-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252FeIwtiPevlQYuy1bQ4x85%252Fuploads%252FG6ojg0BeuaN3i9aonNNq%252Fupload-journal-fliter-example-file.png%3Falt%3Dmedia%26token%3D2fb52b00-e736-4fe6-80d0-1e30a431de30&width=768&dpr=1&quality=100&sign=592e2db490bcacc7dad8f5564b8cbefc&sv=3"
            alt="Filter file example"
            style="max-width: 100%; border: 1px solid #e0e0e0; border-radius: 4px;"
          />
        </div>
        {{ $t('setup.filterFormats') }} <code>.txt</code>, <code>.csv</code>, <code>.xlsx</code>, {{ $t('setup.pricelistFormats') }} <code>.xls</code>.
      </div>
      <v-list>
        <publisher-file file-type="filter"/>
      </v-list>

    </div>
  </v-card>
</template>


<script>
import _ from "lodash"
import {mapGetters, mapMutations, mapActions} from 'vuex'
import PublisherFile from "../PulisherFile/PublisherFile";
import PublisherWarning from "@/components/PublisherWarning/PublisherWarning";

export default {
  name: "PublisherSetupTabFilter",
  components: {
    PublisherFile,
    PublisherWarning,
  },
  props: {},
  data() {
    return {
      counterFileType: "counter-4",
      isUploadFileLoading: false, // temporary to silence console errors
      fileSelected: null,
      errorMsg: null,
    }
  },
  methods: {},
  computed: {
    ...mapGetters([
      "publisherName",
      "publisherId",
      "publisherBigDealCost",
      "publisherFiles",
      "getPublisherDataFile",
      "publisherCounterVersion",
    ]),
  },
  created() {
  },
  mounted() {

  },
  watch: {}
}
</script>

<style lang="scss">


</style>
